import React, { useEffect, useState } from "react";
import { Paper, Tooltip, TextField as TextFieldMaterialUI } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useHistory, useParams } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import MUIDataTable from "../../../components/LegacyMuiDataTable";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

import CustomToolbar from "../../../components/CustomToolbar";
import ConfirmDelete from "../../../components/confirmDelete";
import { BorderLinearProgress } from "../../../components/LoadingComponent";
import NavBar from "../../../components/Navbar";
import { getHRInfoById, deleteHRInfo } from "../../../store/ducks/duckHr";

import HrInfoForm from "./components/HrInfoForm";

const initialHrInfo = {
  id: 0,
  monthNumber: 0,
  url: "",
  hRId: 0,
};

const HrInfo = () => {
  const { hrId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [allLoaded, setAllLoaded] = useState(false);
  const dispatch = useDispatch();

  const data = useSelector((state) => state.hr.dataInfo);
  const loading = useSelector((state) => state.hr.isLoading);
  const history = useHistory();

  const [open, setOpen] = useState(false);
  const [id, setId] = useState(0);
  const [isEdit, setEdit] = useState(false);

  const [hrInfo, setHrInfo] = useState(initialHrInfo);

  const [openConfirm, setOpenConfirm] = useState(false);

  useEffect(() => {
    dispatch(getHRInfoById(hrId)).then(() => setAllLoaded(true));
  }, [hrId, dispatch]);

  useEffect(() => {
    if (hrId && hrId !== "" && data?.length === 0 && allLoaded) {
      enqueueSnackbar("This Hr not have HrInfo assigned", {
        variant: "info",
      });
    }
  }, [hrId, data, dispatch, enqueueSnackbar, allLoaded]);

  const handleClickOpen =
    (hrInfo, isEdit = true) =>
    (event) => {
      event.preventDefault();

      setId(hrInfo?.id || 0);
      setHrInfo(hrInfo);
      setEdit(isEdit);

      setOpen(true);
    };

  const handleClose = () => {
    setHrInfo(initialHrInfo);
    setOpen(false);
  };

  const handleClickReload = () => {
    dispatch(getHRInfoById(hrId));
  };

  const handleConfirm = (hrInfo) => (event) => {
    event.preventDefault();
    setId(hrInfo?.id || 0);

    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleDelete = (event) => {
    event.preventDefault();
    dispatch(deleteHRInfo(id, hrId)).then(() =>
      enqueueSnackbar(`Hr Info Deleted succesfully`, { variant: "info" }),
    );
    handleCloseConfirm();
  };

  const handleRedirect = () => (e) => {
    e.preventDefault();

    history.push(`/Administration/Hr`);
  };

  const columns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: true,
        display: false,
      },
    },
    {
      name: "monthNumber",
      label: "Month Number",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "nowrap",
            position: "sticky",
            left: 0,
            background: "white",
            zIndex: 101,
          },
        }),
      },
    },
    {
      name: "url",
      label: "Url",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "nowrap",
            position: "sticky",
            left: 0,
            background: "white",
            zIndex: 101,
          },
        }),
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        viewColumns: false,
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "nowrap",
            position: "sticky",
            left: 0,
            background: "white",
            zIndex: 101,
          },
        }),
        customBodyRenderLite: (dataIndex) => {
          let rowData = data[dataIndex];

          return (
            <div style={{ maxWidth: 250 }}>
              <Tooltip title={"Edit"}>
                <IconButton aria-label="edit" size="small" onClick={handleClickOpen(rowData, true)}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={rowData.deleted ? "Is already removed" : "Delete"}>
                <IconButton
                  aria-label="delete"
                  disabled={rowData.deleted}
                  size="small"
                  onClick={handleConfirm(rowData)}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Back to Hr"}>
                <IconButton aria-label="open" size="small" onClick={handleRedirect()}>
                  <ExitToAppIcon />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
        setCellProps: () => ({ style: { width: 130 } }),
      },
    },
  ];

  const options = {
    filterType: "dropdown",
    expandableRowsHeader: false,
    selectableRows: "none",
    download: false,
    print: false,
    viewColumns: true,
    customToolbar: () => {
      return (
        <CustomToolbar handleClick={handleClickOpen(hrInfo)} handleReload={handleClickReload} />
      );
    },
    setTableProps: () => {
      return {
        padding: "default",
        size: "small",
      };
    },
    textLabels: {
      body: {
        noMatch: loading ? "loading..." : "Sorry, no matching records found",
      },
    },
    responsive: "standard",
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: "420px",
    jumpToPage: true,
  };

  return (
    <>
      <NavBar />
      <Paper
        style={{
          marginTop: 100,
        }}
      >
        {loading && <BorderLinearProgress />}

        <ConfirmDelete
          handleClose={handleCloseConfirm}
          handleDelete={handleDelete}
          message={`Are you sure to Delete the Hr Info?`}
          open={openConfirm}
        />
        {open && hrInfo && (
          <HrInfoForm
            handleClose={handleClose}
            hrId={hrId}
            initialValues={hrInfo}
            isEdit={isEdit}
            open={open}
          />
        )}
        <MUIDataTable columns={columns} data={data} options={options} title={"Hr Info"} />
      </Paper>
    </>
  );
};

export default HrInfo;
